// extracted by mini-css-extract-plugin
export var gif = "_e7-0";